import { requireDashboardOrigin } from "@api/auth/dashboardOriginGuard"
import { serverRouteConfig } from "@lib/serverRouteConfig"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/api/dashboard/auth/logout")(
  serverRouteConfig({
    server: {
      handlers: {
        POST: async ({ request }) => {
          const originError = requireDashboardOrigin(request)
          if (originError) return originError

          const { logoutDashboardResponse } = await import("@api/auth/dashboardAuthApi")
          return logoutDashboardResponse()
        },
      },
    },
  })
)
